<template>
  <div class="wrap">
    <van-sticky>
      <van-nav-bar title="我的客户" left-arrow @click-left="$router.go(-1)" />
    </van-sticky>
    <div class="teamTop">
      <div class="topBtm">
        <div>直推人数
          <div class="num">
            {{userInfo.total_direct}}
          </div>
        </div>
        <div>团队人数
          <div class="num">
            {{userInfo.group_person_count}}
          </div>
        </div>
      </div>
    </div>
    <!-- 列表 -->
    <!-- <div class="teamList" v-if='teamList.length>0'>
      <div class="teamItem" v-for='(item,index) in teamList' :key='index'>
        <div class='itemSon'>
          <div>{{item.rank_name}}:{{(item.member).replace(/^(\d{3})\d{4}(\d{4})$/,"$1****$2")}}</div>
          <div>{{item.create_time}}</div>
        </div>
        <div class='itemSon'>
          <div>姓名:{{item.total_direct}}</div>
          <div>单量:{{item.group_person_count}}</div>
        </div>
      </div>
    </div> -->
    <!-- <div v-else class="noData">
      暂无数据
    </div> -->
    <el-tree v-show="!showAll" :data="treeData" :props="propSetting" :load="loadMap" lazy>
      <div class="custom-tree-node" slot-scope="{ node, data }">
        <div class="teamItem">
          <div>
            <div>
              手机号：<span  class="textRed"> {{ data.phone }} </span>
            </div>
            <div style="margin-top:10px;">
              真实姓名：<span class="textRed">{{ data.name }}</span>
            </div>
          </div>
          <div style="text-align: right;">
            <div>
              会员级别：<span class="textRed">{{ data.rank_name }}</span>
            </div>
            <div  style="margin-top:10px;">
              注册时间：<span class="textRed">{{ data.create_time }}</span>
            </div>
          </div>
        </div>
      </div>
    </el-tree>
  </div>
</template>
<script>
  import { userInfo } from "@/api/personal";
  import { myTeam } from "@/api/team";
  export default {
    data() {
      return {
        listLoading: true,
        filterMember: "",
        showAll: false,
        treeData: [
        ],
        allTreeData: [],
        propSetting: {
          children: "children",
          label: "member"
        },
        propSetting2: {
          children: "children",
          label: "member"
        },
        expandIdList: [],
        userInfo: {},
        teamData: {},
        teamList: []
      };
    },
    created() {
      this.getSingleMemberTreeInfo();
      userInfo().then(res => {
        this.userInfo = res;
      })
    },
    methods: {
      getSingleMemberTreeInfo() {
        this.showAll = false;
        let member = "";
        this.treeData = [];
        this.initTeamTreeMap(member);
      },
      getAllMemberTreeInfo() {
        this.showAll = true;
        let member = this.filterMember || "";
        this.allTreeData = [];
        this.getAll(member);
      },
      initTeamTreeMap(member) {
        this.listLoading = true;
        myTeam(member).then(resp => {
          this.treeData = resp;
          this.listLoading = false;

        });
      },
      getAll(member) {
        myTeam(member).then(resp => {
          let allMemberIds = resp.map(item => {
            return item.id;
          });
          this.expandIdList = allMemberIds;

          let root = resp[0];
          // 整理数据，生成children结构
          resp.forEach(outerItem => {
            resp.forEach((item, index, resp) => {
              if (item.pid == outerItem.id) {
                if (!outerItem.children) {
                  outerItem.children = [];
                }
                outerItem.children.push(

                );
              }
            });
          });

          this.allTreeData = [];
          this.allTreeData.push(root);
          this.listLoading = false;
        });
      },
      loadMap(node, resolve) {
        if (node.level ==1||node.level==2) {
          myTeam(node.data.id).then(resp => {
            resolve(resp);
          });
        }else{
          return;
        }
      }
    }
  };
</script>
<style lang='less' scoped>
  .wrap {
    height: 100vh;
    background: #fff;
    color: #343434;
    font-size: 14px;

    .teamTop {
      width: 100%;
      padding: 11px 20px 19px;
      box-sizing: border-box;
      text-align: center;

      .topBtm {
        margin-top: 25px;
        display: flex;
        justify-content: space-between;

        &>div {
          width: 33.3%;
        }

        div.num {
          color: #3B6BFB;
          font-size: 18px;
          margin-top: 8.5px;
        }
      }
    }

    .gap {
      width: 100%;
      height: 10px;
      background: #ececec;
    }

    .teamList {
      width: 100%;
      box-sizing: border-box;
      padding: 0 15px;


    }
  }

  .itemSon {
    width: 100%;
    display: flex;
    justify-content: space-around;
    margin-bottom: 10px;
    flex-wrap: wrap;

    div {
      width: 50%;

      &:last-child {
        text-align: right;
      }
    }
  }

  .textRed {
    color: red;
  }

  .teamItem {
    display: flex;
    justify-content: space-between;
  }

  /deep/ .el-tree-node__content {
    height: 70px;
    padding-left:5px!important;
  }
  /deep/ .el-icon-loading:before{
    content:""
  }
</style>